module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/wTZLz5/tc-custom/9780888645906.jpg?1737758121336",
      "alt": "This image is the cover for the book Heavy Burdens on Small Shoulders"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Heavy Burdens on Small Shoulders\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Focusing on children’s work on family farms in western Canada, an “absolutely fascinating . . . marvellously fresh account of the lives of prairie pioneers.” —"), _c('i', [_vm._v("The Calgary Herald")])]), _c('br'), _c('br'), _vm._v("The phrase “child labour” carries negative undertones in today’s society. However, only a century ago on the Canadian Prairies, youngsters laboured alongside their parents, working the land, cleaning stovepipes, and chopping wood. By shouldering their share of the chores, these children learned the domestic and manual labour skills needed for life on a Prairie family farm. "), _c('br'), _c('br'), _vm._v("Sandra Rollings-Magnusson uses historic research, photographs, and personal anecdotes to describe the kinds of work performed by children and how each task fit into the family economy. This book is a vital contribution to western Canadian history as well as family and gender studies.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sandra Rollings-Magnusson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Sandra Rollings-Magnusson teaches sociology at MacEwan College. Her research interests include political economy, sociology of the family, social policy, and gender and ethnic studies. She is currently researching the economic, political, and social lives of pioneer families on the western prairies. Rollings-Magnusson lives in Edmonton.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    University of Alberta Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0